import { effect, inject, Injector, runInInjectionContext } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Auth guard: waits for the initial session check to finish, then either
 * permits the route or redirects to /login with a `redirect` query param.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const injector = inject(Injector);

  if (!auth.isLoading()) {
    return resolve(auth, router, state.url);
  }

  return new Promise<boolean>((resolveFn) => {
    runInInjectionContext(injector, () => {
      const ref = effect(() => {
        if (auth.isLoading()) return;
        ref.destroy();
        resolveFn(resolve(auth, router, state.url));
      });
    });
  });
};

function resolve(auth: AuthService, router: Router, target: string): boolean {
  if (auth.isAuthenticated()) return true;
  void router.navigate(['/login'], { queryParams: { redirect: target } });
  return false;
}
